import { createSlice } from '@reduxjs/toolkit';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';

const testPlansSlice = createSlice({
    name: '@testPlans',
    initialState: {
        testPlans: [],
        testPlansCount: 0,
        testPlanActual: null,
        testPlanLocal: null,
        getStatus: REQUEST_STATUS.NOT_REQUESTED,
        getError: null,
        getTestPlanByIdStatus: REQUEST_STATUS.NOT_REQUESTED,
        getTestPlanByIdError: null,
        addStatus: REQUEST_STATUS.NOT_REQUESTED,
        addError: null,
        addedTestplanId: null,
        editStatus: REQUEST_STATUS.NOT_REQUESTED,
        editError: null,
        deleteStatus: REQUEST_STATUS.NOT_REQUESTED,
        deleteError: null,
        duplicateStatus: REQUEST_STATUS.NOT_REQUESTED,
        duplicateError: null,
        isTestPlanEverSaved: false,
        testCasesFilteredByTestPlan: [],
        testCasesFilteredByTestPlanCount: 0,
        getTestCasesFilteredByTestPlanStatus: REQUEST_STATUS.NOT_REQUESTED,
        getTestCasesFilteredByTestPlanError: null,
        getTestPlanForUpdateTestRunStatus: REQUEST_STATUS.NOT_REQUESTED,
        getTestPlanForUpdateTestRunError: null,
        addTestcasesToTestplanStatus: REQUEST_STATUS.NOT_REQUESTED,
        addTestcasesToTestplanError: null,
        deleteTestcasesFromTestplanStatus: REQUEST_STATUS.NOT_REQUESTED,
        deleteTestcasesFromTestplanError: null,
        testplanType: null,
        getTestplanTypeStatus: REQUEST_STATUS.NOT_REQUESTED,
        getTestplanTypeError: null,
    },
    reducers: {
        // READ
        getTestPlansRequest(state) {
            state.getStatus = REQUEST_STATUS.LOADING;
            state.getError = null;
        },
        getTestPlansSuccess(state, action) {
            state.getStatus = REQUEST_STATUS.SUCCESS;
            state.getError = null;
            state.testPlans = action.payload.data.items;
            state.testPlansCount = action.payload.data.count;
        },
        getTestPlansError(state, action) {
            state.getStatus = REQUEST_STATUS.ERROR;
            state.getError = action;
            state.testPlans = [];
        },
        getTestPlansReset(state) {
            state.getStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getError = null;
            state.testPlans = [];
        },

        // One test plan
        getTestPlanByIdRequest(state) {
            state.getTestPlanByIdStatus = REQUEST_STATUS.LOADING;
            state.getTestPlanByIdError = null;
        },
        getTestPlanByIdSuccess(state, action) {
            state.getTestPlanByIdStatus = REQUEST_STATUS.SUCCESS;
            state.getTestPlanByIdError = null;
            state.testPlanActual = action.payload.data;
            state.testPlanLocal = action.payload.data;
        },
        getTestPlanByIdError(state, action) {
            state.getTestPlanByIdStatus = REQUEST_STATUS.ERROR;
            state.getTestPlanByIdError = action;
            state.testPlanActual = null;
            state.testPlanLocal = null;
        },
        getTestPlanByIdReset(state) {
            state.getTestPlanByIdStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getTestPlanByIdError = null;
            state.testPlanActual = null;
            state.testPlanLocal = null;
        },

        // CREATE
        addTestPlanRequest(state) {
            state.addStatus = REQUEST_STATUS.LOADING;
            state.addError = null;
        },
        addTestPlanSuccess(state, action) {
            state.addStatus = REQUEST_STATUS.SUCCESS;
            state.addError = null;
            state.addedTestplanId = action.payload.data.pk;

            state.getStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getError = null;
        },
        addTestPlanError(state, action) {
            state.addStatus = REQUEST_STATUS.ERROR;
            state.addError = action;
        },
        addTestPlanReset(state) {
            state.addStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.addError = null;
            state.addedTestplanId = null;
        },

        // UPDATE
        editTestPlanRequest(state) {
            state.editStatus = REQUEST_STATUS.LOADING;
            state.editError = null;
        },
        editTestPlanSuccess(state) {
            state.editStatus = REQUEST_STATUS.SUCCESS;
            state.editError = null;

            state.getTestPlanByIdStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getTestPlanByIdError = null;
        },
        editTestPlanError(state, action) {
            state.editStatus = REQUEST_STATUS.ERROR;
            state.editError = action;
        },
        editTestPlanReset(state) {
            state.editStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.editError = null;
        },

        // DELETE
        deleteTestPlanRequest(state) {
            state.deleteStatus = REQUEST_STATUS.LOADING;
            state.deleteError = null;
        },
        deleteTestPlanSuccess(state) {
            state.deleteStatus = REQUEST_STATUS.SUCCESS;
            state.deleteError = null;

            state.getStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getError = null;
        },
        deleteTestPlanError(state, action) {
            state.deleteStatus = REQUEST_STATUS.ERROR;
            state.deleteError = action;
        },
        deleteTestPlanReset(state) {
            state.deleteStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.deleteError = null;
        },
        // DUPLICATE
        duplicateTestplanRequest(state) {
            state.duplicateStatus = REQUEST_STATUS.LOADING;
            state.duplicateError = null;
        },
        duplicateTestplanSuccess(state) {
            state.duplicateStatus = REQUEST_STATUS.SUCCESS;
            state.duplicateError = null;
        },
        duplicateTestplanError(state, action) {
            state.duplicatenStatus = REQUEST_STATUS.ERROR;
            state.duplicateError = action.payload;
        },
        duplicateTestplanReset(state) {
            state.duplicateStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.duplicateError = null;
        },
        // REVERT & UPDATE
        revertTestPlanLocalChanges(state) {
            state.testPlanLocal = state.testPlanActual;
        },
        updateTestplan(state, action) {
            const { field, value } = action.payload;
            state.testPlanLocal[field] = value;
        },
        // Testcases by tesplan
        getTestCasesFilteredByTestPlanRequest(state) {
            state.getTestCasesFilteredByTestPlanStatus = REQUEST_STATUS.LOADING;
            state.getTestCasesFilteredByTestPlanError = null;
        },
        getTestCasesFilteredByTestPlanSuccess(state, action) {
            state.getTestCasesFilteredByTestPlanStatus = REQUEST_STATUS.SUCCESS;
            state.getTestCasesFilteredByTestPlanError = null;
            state.testCasesFilteredByTestPlan = action.payload.data.items;
            state.testCasesFilteredByTestPlanCount = action.payload.data.count;
        },
        getTestCasesFilteredByTestPlanError(state, action) {
            state.getTestCasesFilteredByTestPlanStatus = REQUEST_STATUS.ERROR;
            state.getTestCasesFilteredByTestPlanError = action;
        },
        getTestCasesFilteredByTestPlanReset(state) {
            state.getTestCasesFilteredByTestPlanStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getTestCasesFilteredByTestPlanError = null;
            state.testCasesFilteredByTestPlan = [];
            state.testCasesFilteredByTestPlanCount = 0;
        },

        // get TestPlan for update
        getTestPlanForUpdateTestRunRequst(state) {
            state.getTestPlanForUpdateTestRunStatus = REQUEST_STATUS.LOADING;
            state.getTestPlanForUpdateTestRunError = null;
        },
        getTestPlanForUpdateTestRunSuccess(state, action) {
            state.getTestPlanForUpdateTestRunStatus = REQUEST_STATUS.SUCCESS;
            state.getTestPlanForUpdateTestRunError = null;
            const updateIndex = state.testPlans.findIndex((item) => item.pk === action.payload.data.pk);

            if (updateIndex !== -1) {
                state.testPlans[updateIndex] = action.payload.data;
            }
        },
        getTestPlanForUpdateTestRunError(state, action) {
            state.getTestPlanForUpdateTestRunStatus = REQUEST_STATUS.ERROR;
            state.getTestPlanForUpdateTestRunError = action;
        },
        getTestPlanForUpdateTestRunReset(state) {
            state.getTestPlanForUpdateTestRunStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getTestPlanForUpdateTestRunError = null;
        },

        // add, delete testcases from testplan
        addTestcasesToTestplanRequest(state) {
            state.addTestcasesToTestplanStatus = REQUEST_STATUS.LOADING;
            state.addTestcasesToTestplanError = null;
        },
        addTestcasesToTestplanSuccess(state) {
            state.addTestcasesToTestplanStatus = REQUEST_STATUS.SUCCESS;
            state.addTestcasesToTestplanError = null;
        },
        addTestcasesToTestplanError(state, action) {
            state.addTestcasesToTestplanStatus = REQUEST_STATUS.ERROR;
            state.addTestcasesToTestplanError = action.payload;
        },
        addTestcasesToTestplanReset(state) {
            state.addTestcasesToTestplanStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.addTestcasesToTestplanError = null;
        },
        deleteTestcasesFromTestplanRequest(state) {
            state.deleteTestcasesFromTestplanStatus = REQUEST_STATUS.LOADING;
            state.deleteTestcasesFromTestplanError = null;
        },
        deleteTestcasesFromTestplanSuccess(state) {
            state.deleteTestcasesFromTestplanStatus = REQUEST_STATUS.SUCCESS;
            state.deleteTestcasesFromTestplanError = null;
        },
        deleteTestcasesFromTestplanError(state, action) {
            state.deleteTestcasesFromTestplanStatus = REQUEST_STATUS.ERROR;
            state.deleteTestcasesFromTestplanError = action.payload;
        },
        deleteTestcasesFromTestplanReset(state) {
            state.deleteTestcasesFromTestplanStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.deleteTestcasesFromTestplanError = null;
        },
        getTestplanTypeRequest(state) {
            state.getTestplanTypeStatus = REQUEST_STATUS.LOADING;
            state.getTestplanTypeError = null;
        },
        getTestplanTypeSuccess(state, action) {
            state.getTestplanTypeStatus = REQUEST_STATUS.SUCCESS;
            state.testplanType = action.payload.type;
            state.getTestplanTypeError = null;
        },
        getTestplanTypeError(state, action) {
            state.getTestplanTypeStatus = REQUEST_STATUS.ERROR;
            state.getTestplanTypeError = action.payload;
        },
        getTestplanTypeReset(state) {
            state.getTestplanTypeStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.testplanType = null;
            state.getTestplanTypeError = null;
        },
    },
});

export default testPlansSlice.reducer;

export const {
    getTestPlansRequest,
    getTestPlansSuccess,
    getTestPlansError,
    getTestPlansReset,
    getTestPlanByIdRequest,
    getTestPlanByIdSuccess,
    getTestPlanByIdError,
    getTestPlanByIdReset,
    addTestPlanRequest,
    addTestPlanSuccess,
    addTestPlanError,
    addTestPlanReset,
    editTestPlanRequest,
    editTestPlanSuccess,
    editTestPlanError,
    editTestPlanReset,
    deleteTestPlanRequest,
    deleteTestPlanSuccess,
    deleteTestPlanError,
    deleteTestPlanReset,
    duplicateTestplanRequest,
    duplicateTestplanSuccess,
    duplicateTestplanError,
    duplicateTestplanReset,
    revertTestPlanLocalChanges,
    updateTestplan,
    getTestCasesFilteredByTestPlanRequest,
    getTestCasesFilteredByTestPlanSuccess,
    getTestCasesFilteredByTestPlanError,
    getTestCasesFilteredByTestPlanReset,
    getTestPlanForUpdateTestRunRequst,
    getTestPlanForUpdateTestRunSuccess,
    getTestPlanForUpdateTestRunError,
    getTestPlanForUpdateTestRunReset,
    addTestcasesToTestplanRequest,
    addTestcasesToTestplanSuccess,
    addTestcasesToTestplanError,
    addTestcasesToTestplanReset,
    deleteTestcasesFromTestplanRequest,
    deleteTestcasesFromTestplanSuccess,
    deleteTestcasesFromTestplanError,
    deleteTestcasesFromTestplanReset,
    getTestplanTypeRequest,
    getTestplanTypeSuccess,
    getTestplanTypeError,
    getTestplanTypeReset,
} = testPlansSlice.actions;
